import { createSlice } from "@reduxjs/toolkit";
import {
  fetchHotelBooking,
  fetchOneHotelBooking,
  fetchOneHotelSettlement,
  fetchHotelSettlement,
  generateHotelSettlement,
  hotelPaymentDetailsGenerated,
  updateHotelCheckInStatus,
  updateHotelCheckOutStatus,
  updateHotelBooking,
  exchangeHotelBooking,
  fetchHotelBookingCounts,
  upcomingRejectHotelBooking,
} from "./bookingThunks";

const initialState = {
  booking: [],
  settlement: [],
  bookingCounts: null,
  oneBooking: null,
  oneSettlement: null,
  loading: false,
  error: null,
  totalPages: 1,
  totalItems: 0,
};
const hotelSlice = createSlice({
  name: "hotelBooking",
  initialState,

  extraReducers: (builder) => {
    builder
      // get All Hotel Booking
      .addCase(fetchHotelBooking.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchHotelBooking.fulfilled, (state, action) => {
        state.booking = action.payload.data;
        state.totalPages = action.payload.totalPages;
        state.totalItems = action.payload.totalItems;
        state.loading = false;
        // state.sumAmounts = action.payload.sumAmounts;
      })
      .addCase(fetchHotelBooking.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(exchangeHotelBooking.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchHotelBookingCounts.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchHotelBookingCounts.fulfilled, (state, action) => {
        state.bookingCounts = action.payload;
        state.loading = false;
      })
      .addCase(fetchHotelBookingCounts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }) // get One Hotel Booking
      .addCase(fetchOneHotelBooking.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOneHotelBooking.fulfilled, (state, action) => {
        state.oneBooking = action.payload;
        state.loading = false;
      })
      .addCase(fetchOneHotelBooking.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateHotelBooking.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateHotelBooking.fulfilled, (state, action) => {
        if (state.oneBooking) {
          state.oneBooking = {
            ...state.oneBooking,
            bookingStatus: action.payload.bookingStatus,
          };
        }
        state.loading = false;
      })
      .addCase(updateHotelBooking.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }) // Update Settlement Status
      .addCase(generateHotelSettlement.pending, (state) => {
        state.loading = true;
      })
      .addCase(generateHotelSettlement.fulfilled, (state, action) => {
        const updatedIds = action.payload;
        state.booking = state.booking.filter(
          (booking) => !updatedIds.includes(booking._id)
        );
        state.loading = false;
      })
      .addCase(generateHotelSettlement.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchHotelSettlement.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchHotelSettlement.fulfilled, (state, action) => {
        state.settlement = action.payload.data;
        state.totalPages = action.payload.totalPages;
        state.totalItems = action.payload.totalItems;
        state.loading = false;
      })
      .addCase(fetchHotelSettlement.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchOneHotelSettlement.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOneHotelSettlement.fulfilled, (state, action) => {
        state.oneSettlement = action.payload;
        state.loading = false;
      })
      .addCase(fetchOneHotelSettlement.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(hotelPaymentDetailsGenerated.fulfilled, (state, action) => {
        state.settlement = state.settlement.filter(
          (settlement) => settlement._id !== action.payload
        );
        state.loading = false;
      })
      .addCase(hotelPaymentDetailsGenerated.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateHotelCheckInStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateHotelCheckInStatus.fulfilled, (state, action) => {
        state.booking = state.booking.filter(
          (booking) => booking._id !== action.payload
        );
        state.loading = false;
      })
      .addCase(updateHotelCheckInStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateHotelCheckOutStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateHotelCheckOutStatus.fulfilled, (state, action) => {
        state.booking = state.booking.filter(
          (booking) => booking._id !== action.payload
        );
        state.loading = false;
      })
      .addCase(updateHotelCheckOutStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(exchangeHotelBooking.pending, (state) => {
        state.loading = true;
      })
      .addCase(exchangeHotelBooking.fulfilled, (state, action) => {
        if (state.oneBooking) {
          state.oneBooking = {
            ...state.oneBooking,
            couponDetails: action.payload,
          };
        }
        state.loading = false;
      })
      .addCase(upcomingRejectHotelBooking.pending, (state) => {
        state.loading = true;
      })
      .addCase(upcomingRejectHotelBooking.fulfilled, (state, action) => {
        const rejectedIds = action.payload;
        if (rejectedIds) {
          state.booking = state.booking.filter(
            (booking) => !rejectedIds.includes(booking._id)
          );
        }
        state.loading = false;
      })
      .addCase(upcomingRejectHotelBooking.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export default hotelSlice.reducer;
